<template>
  <router-view/>
</template>

<script>
  export default {
    name: 'ChronotachographHistory',
  }
</script>

<style scoped>
</style>